var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import BrandAvatar from "@irati/ui/src/BrandAvatar";
export default styled(BrandAvatar)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  transform: translate(", ", 0);\n  left: ", ";\n  bottom: -", ";\n\n  ", "\n"], ["\n  position: absolute;\n  transform: translate(", ", 0);\n  left: ", ";\n  bottom: -", ";\n\n  ",
    "\n"])), function (_a) {
    var compactMode = _a.compactMode;
    return (compactMode ? "-50%" : 0);
}, function (_a) {
    var theme = _a.theme, compactMode = _a.compactMode;
    return (compactMode ? "50%" : theme.spacing.two);
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.two;
}, function (_a) {
    var theme = _a.theme, compactMode = _a.compactMode;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    left: ", ";\n    bottom: -", ";\n    width: 80px;\n    height: 80px;\n  "], ["\n    left: ", ";\n    bottom: -", ";\n    width: 80px;\n    height: 80px;\n  "])), compactMode ? "50%" : theme.spacing.four, theme.spacing.three);
});
var templateObject_1, templateObject_2;
